const PROTOCOL = process.env.VUE_APP_PROTOCOL;
const ROOT_DOMAIN = process.env.VUE_APP_ROOT_DOMAIN;

export const ROOT_URL = `${PROTOCOL}://${ROOT_DOMAIN}`;
export const API_URL = `${PROTOCOL}://api.${ROOT_DOMAIN}`;
export const PARTNER_URL = `${PROTOCOL}://partner.${ROOT_DOMAIN}`;
export const EXTERNAL_URL = `${PROTOCOL}://mon-espace.${ROOT_DOMAIN}`;
